<template>
  <div class="DataTables LibraryDetailsComponent ">

    <p v-if="!isRevision">{{lang.infotext_1}}</p>
    <LoaderComponent v-if="!isData"></LoaderComponent>

    <span v-if="selectedRevisionRow.length > 0">
      <div :id="id"></div>
      <div v-if="libraryType == 'hdl symbol'" class="tree-empty"></div>
      <div v-if="libraryType == 'hdl symbol'" class="tree-container" id="treeContainer">
        <div :id="'place_'+rev" class="tree-folders" v-for="(rev, index) in propertiesRevNumbers" :key="index">
          <div class="tree">
            <FoldersTreeHDLComponent :isPending="lastPendingRevision" :lastRevisionHistory="lastRevisionHistory"
              :revisionId="rev" :lang="lang.FolderTree" isCategory="edit" parent="details"></FoldersTreeHDLComponent>
          </div>
        </div>
      </div>
      <p v-show="isEdit">{{lang.infotext_2}}:</p>

      <b-form-file v-show="isEdit" class="library-files" v-model="libraryFiles" :placeholder="lang.filesPlaceholder"
        drop-placeholder="Drop file here..." multiple></b-form-file>
      <br><br>
      <p v-show="isEdit"><b-badge class="badge badge-blue">Request</b-badge> - {{lang.infotext_Request}}</p>
      <p v-show="isEdit"><b-badge class="badge badge-yellow">Release</b-badge> - {{lang.infotext_Release}}</p>
      <p v-show="isEdit"><b-badge class="badge badge-danger">Revision</b-badge> - {{lang.infotext_Revision}}</p>
    </span>
  </div>
</template>
<script>
  import LibraryTypes from '@/constants/LibraryTypes'
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import FoldersTreeHDLComponent from "@/components/shared/FoldersTreeHDLComponent"
  import * as Tools from '@/Tools/Tools'
  import { mapGetters } from 'vuex'
import LibraryPropertiesType from '../../constants/LibraryPropertiesType'


  export default {
    name: "LibraryDetailsComponent",
    props:{
      lang: Object
    },
    components: {
      FoldersTreeHDLComponent,
      LoaderComponent
    },
    data () {
      return {

        mainTable: "",
        id: "LibraryDetailsComponent",
        properties: [],
        pureProperties: [],
        propertiesRevNumbers: [],
        colorValues: [],
        currentPackage: {},
        packages: {},
        symbolSvg: {},
        place: {},
        currentRevisionId: "",
        libraryFiles: null,
        libraryTypes: [],
        listAllRevisionFiles: {},
        listAllImageTriggers: {},
        libraryType: "",
        verCounter: 0,
      }
    },
    computed: {
      ...mapGetters({

        globalSettings: "globalSettings"

      }),
      lastPendingRevision() {
        let trig = false;
        for (let i = 0, lei = this.$store.getters.revisionHistory.length; i < lei; i++) {
          
          if (this.$store.getters.revisionHistory[i].id == this.propertiesRevNumbers[0]) {
            if (this.$store.getters.revisionHistory[i].status.display == "pending") {
              trig = true;
              break;
            }
          }
        }
        return trig;
      },
      revisionQuantity(){
        return this.$store.getters.selectedRevisionRow.length;
      },
      isEdit(){
        return this.$store.getters.isEditPropertyForm;
      },
      selectedRevisionRow(){
        return this.$store.getters.selectedRevisionRow;
      },
      isData() {
        
        return this.properties.length == this.$store.getters.selectedRevisionRow.length;
      },
      isRevision(){

        return this.$store.getters.selectedRevisionRow.length != 0;

      },
      lastRevisionHistory(){
  
        let tab = this.$store.getters.revisionHistory;
        let obj = tab[0];
        for (let i = 0, lei = tab.length; i < lei; i++){
          
          if (tab[i].revision > obj.revision){
            obj = tab[i];
          }
        }
        
        return obj;
      },
      selectedLastRevisionRow(){
        if (this.$store.getters.selectedRevisionRow.length == 0){
          return false;
        }
        return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
      },
      variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
          return "light";
        }else{
          return "dark";
        }
        
      },
      propertyToSaving() {
        return this.$store.getters.propertyToSaving;
      },

    },
  created() {

    this.$store.dispatch("deselectAllRevisionRow");

        let vue = this;

        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibraryType")
        .then(function(result) {
          
          console.log(result)

          if (result.status == "OK"){

            vue.libraryTypes = [""];
            result.data.forEach(element => {
                vue.libraryTypes.push(element.type);
            });

          }
        })
      

      //this.loadDataForRevisions();

      this.$store.dispatch("setSaveStatus", false);

    },
    watch: {
      
      isEdit: function(){
        
      
        this.loadDataForRevisions();
      },
      verCounter: function(newVal){
        
        if (newVal == this.revisionQuantity){
          
          
          if (this.properties.length != 0){
            
            for (let i = 0; i < this.propertiesRevNumbers.length; i++) {
              for (let j = 0; j < this.propertiesRevNumbers.length - i - 1; j++) {
                if (this.propertiesRevNumbers[j] < this.propertiesRevNumbers[j + 1]) {
                  const temp = this.propertiesRevNumbers[j + 1];
                  const temp2 = this.properties[j + 1];
                  this.propertiesRevNumbers[j + 1] = this.propertiesRevNumbers[j];
                  this.properties[j + 1] = this.properties[j];
                  this.propertiesRevNumbers[j] = temp;
                  this.properties[j] = temp2;

                }
              }
            }
           


            let partsData = [];

            for(let i = 0, lei = this.properties[0].length; i < lei; i++){
              let objRow = {
                id:  this.properties[0][i].id,
                name: this.properties[0][i].name,
                priority: this.properties[0][i].priority,
                type: this.properties[0][i].type,
                isRequiredOnRequest: this.properties[0][i].isRequiredOnRequest,
                isRequiredOnRelease: this.properties[0][i].isRequiredOnRelease,
                isRevisionChanging: this.properties[0][i].isRevisionChanging
              }

              if (this.properties[0][i].type == "library type"){
                this.libraryType = this.properties[0][i].value.display;
              }
              

              for(let j = 0, lej = this.properties.length; j < lej; j++){


                let revValue = [];
                let isTheSame = [];
                for(let k = 0, lek = this.properties[j].length; k < lek; k++){

                  if (this.properties[j][k].value == null){

                    this.properties[j][k].value = {display: "", filter: "", sort: ""}

                  }


                  if(this.properties[0][k].value.display == this.properties[j][k].value.display){
                    this.properties[j][k].isTheSameLikeLastRev = true;
                  }else{
                    this.properties[j][k].isTheSameLikeLastRev = false;
                  }

                  revValue.push(this.properties[j][k].value);
                  isTheSame.push(this.properties[j][k].isTheSameLikeLastRev);
                }

                
                let key = "value___" + this.propertiesRevNumbers[j];

                objRow[key] = revValue[i];
                objRow.value = revValue[i].display;
                objRow.isTheSameLikeLastRev = isTheSame[i];
                
              }


              partsData.push(objRow);
            }
           
            const objFiles = {
              name: "Files",
              id: 1,
              type: "files",
              priority: 999,
              isRequiredOnRelease: false,
              isRequiredOnRequest: false,
              isRevisionChanging: true,
              value: "f",
              
            }
            for(let j = 0, lej = this.propertiesRevNumbers.length; j < lej; j++){

              

              let key = "value___" + this.propertiesRevNumbers[j];
              objFiles[key] = {
                display: "f"+j,
                sort: "f"+j,
                filter: "f"+j
              }
            }
            
            

            partsData.push(objFiles);

            this.setDifferentForFiles();
            this.buildTable(partsData);
          }
        }
      },
      
      
      selectedRevisionRow: {
        handler: function(newVal, oldVal){
          
          if (newVal.length > 0) {
            
              
              this.loadDataForRevisions();
            
                
          } else {
            this.verCounter = 0;
            this.properties = [];
            this.propertiesRevNumbers = [];
          }
        },
        deep: true
      
        
      },
              

      libraryFiles: function (newVal) {
      
        this.$store.dispatch("setSaveStatus", true);
        this.$store.dispatch("addLibraryFilesToSaving", newVal);
      }
    },
      
    methods: {
      checkIfSaved() {

        let trig = false;
        for (let i = 0, lei = this.properties[0].length; i < lei; i++) {

          if (this.pureProperties[i].value.display != this.propertyToSaving[i].value) {

            trig = true;
          }
        }

        if (trig == true) {
          this.$store.dispatch("setSaveStatus", true)
        } else {
          this.$store.dispatch("setSaveStatus", false)
        }
      },
      setDifferentForFiles(){

        let rev = []
        for (let el in this.listAllRevisionFiles){
          
          rev.push(parseInt(el))
        }
        
        let currentRev = Math.max(...rev);
        const currentObjectRev = this.listAllRevisionFiles[currentRev]
        

        for (let el in this.listAllRevisionFiles){
          for (let i = 0, lei = currentObjectRev.length; i < lei; i++){ 
            
            for (let j = 0, lej = this.listAllRevisionFiles[el].length; j < lej; j++){ 
              
              if (currentObjectRev[i].name == this.listAllRevisionFiles[el][j].name){
                
                if (currentObjectRev[i].guid == this.listAllRevisionFiles[el][j].guid){
                  
                  this.listAllRevisionFiles[el][j].dif = true;
                }else{
                  this.listAllRevisionFiles[el][j].dif = false;
                }
                break;
              }
            }
            
          }
          
          
        }

      },
      setPackage(revisionId){
        
        let barValue = document.getElementById("barDetailValue_" + revisionId + "_" + this.id);
        if (barValue != null){
          let index = this.currentPackage[revisionId] + 1;
          barValue.value = this.packages[revisionId][this.currentPackage[revisionId]] + " (" + index + "/" + this.packages[revisionId].length +")";

          let leftbar = document.getElementById("leftbarDetail_" + revisionId + "_" + this.id);
          let rightbar = document.getElementById("rightbarDetail_" + revisionId + "_" + this.id);

          if (this.currentPackage[revisionId] == 0){
            leftbar.disabled = true;
          }else{
            leftbar.disabled = false;
          }
          
          if (this.currentPackage[revisionId] == this.packages[revisionId].length - 1){
            rightbar.disabled = true;
          }else{
            rightbar.disabled = false;
          }

                      
          
          for (var i = 0, le = this.packages[revisionId].length; i < le; i++) {
              var layer = "PACKAGES_"+this.packages[revisionId][i];

              if (i == this.currentPackage[revisionId]) {
                  if (this.place[revisionId].getElementsByClassName(layer)[0] != undefined) {
                      this.place[revisionId].getElementsByClassName(layer)[0].style["visibility"] = "visible";
                  }
                  

              } else {
                  if (this.place[revisionId].getElementsByClassName(layer)[0] != undefined) {
                      this.place[revisionId].getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                  }
              }


          }
        }
      },
      buildSymbolViewer(place, revisionId){

        let vue = this;
        
        //let svg  = doc.firstChild

        this.place[revisionId] = place;

        
        let symbolbar = document.getElementById("bar_" + this.place[revisionId].id + "_" + this.id);
        
        symbolbar.innerHTML = "";
        
        let group = this.place[revisionId].getElementsByTagName(`g`);
        
        this.packages[revisionId] = [];
        this.currentPackage[revisionId] = 0;
        for (let i = 0, lei = group.length; i < lei; i++){
          
          let temp = group[i].className.baseVal.split("_");
          if (temp[0] == "PACKAGES"){
            
            this.packages[revisionId].push(temp[1])
          }
        }
  

        if(this.packages[revisionId].length > 1){
          
          //this.symbolSvg = svg;

          
          
          
          
          let index = this.currentPackage[revisionId] + 1;
          let valueBar = this.packages[revisionId][this.currentPackage[revisionId]] + " (" + index + "/" + this.packages[revisionId].length +")";

          const bar = `<div role="group" class="input-group  input-group-sm">
                      <div class="input-group-prepend">
                      <button disabled="disabled" id="leftbarDetail_`+revisionId+"_"+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+` btn-bar">&lt;</button>
                      </div> 
                      <input type="text" class="form-control form-control-sm" disabled="disabled" id="barDetailValue_`+revisionId+"_"+this.id+`" value="`+ valueBar +`" style="text-align:center;"> 
                      <div class="input-group-append">
                      <button id="rightbarDetail_`+revisionId+"_"+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+` btn-bar">&gt;</button>
                      </div>
                      </div>`;

          symbolbar.innerHTML = bar;

          let leftbar = document.getElementById("leftbarDetail_" + revisionId + "_" + this.id);
          leftbar.addEventListener("click", function(e) {

            vue.currentRevisionId = revisionId;
            
            if (vue.currentPackage[revisionId] == 0){
              
            }else{
              
              vue.currentPackage[revisionId]--;
              vue.setPackage(revisionId);
            }
            
          })
          
          let rightbar = document.getElementById("rightbarDetail_" + revisionId + "_" + this.id);
          rightbar.addEventListener("click", function(e) {
            
            //vue.currentRevisionId = revisionId;

            if (vue.currentPackage[revisionId] == vue.packages[revisionId].length){
              
            }else{
              
              vue.currentPackage[revisionId]++;
              vue.setPackage(revisionId);
            }
            
          })

          


        }else{
            //this.symbolSvg = {};
        }

        

        

      },
      async loadSVG(result, id, revisionId, libType){

        
        let place = document.getElementById(id);

        if (place != null) {
          place.innerHTML = "";
          let loaderplace = document.getElementById("loader_" + id);
          
          loaderplace.classList.add("nodisplay");
          let pinplace = document.getElementById("pin_" + id);

          if (result.noImage == false) {
            
            place.classList.remove("nodisplay");

            if (pinplace != null && libType == LibraryTypes.PART) {
              pinplace.classList.remove("nodisplay");
            }
            
            let svgData = await new Response(result).text();
            var parser = new DOMParser();
            var doc = parser.parseFromString(svgData, "image/svg+xml");
            doc.documentElement.setAttribute("width", 200);
            doc.documentElement.setAttribute("height", 200);
                
            //injection styles for svg
            const stylesDefs = document.createElement("defs");
            const style = document.createElement("style");
            const tx = document.createTextNode(".GRAPHIC { stroke:#40a040; }");
            style.appendChild(tx);
            stylesDefs.appendChild(style);
            doc.documentElement.appendChild(stylesDefs);

            place.appendChild(doc.documentElement);
          } else {
            let classList = place.classList;
            let t = [];
            for (let i = 0, lei = classList.length; i < lei; i++){
              t.push(classList[i]);
            }
            if (!t.includes("nodisplay")) {
              
              place.classList.add("nodisplay");
            } 
              
            if (pinplace != null) {
              pinplace.classList.add("nodisplay");
            }
          }

          if (place.dataset.type == LibraryTypes.PART || place.dataset.type == LibraryTypes.SYMBOL || place.dataset.type == LibraryTypes.HDLSYMBOL){
            
            this.buildSymbolViewer(place, revisionId);
          }

          
        }

                
        if (place != null){
          
          let pinplace = document.getElementById("pin_" + id);

          // if (result.noImage == false) {
          //   if (libType == "footprint") {
          //     place.classList.add("image-footprint");
          //   } else {
          //     place.classList.add("image-symbol");
          //   }

          //   place.classList.add("image-zoom");


          //   if (pinplace != null && libType == LibraryTypes.PART) {
          //     pinplace.classList.remove("nodisplay");
          //   }
          //   let svgData = await new Response(result).text();
          //   var parser = new DOMParser();
          //   var doc = parser.parseFromString(svgData, "image/svg+xml");
          //   doc.documentElement.setAttribute("width", 200);
          //   doc.documentElement.setAttribute("height", 200);

          //   place.appendChild(doc.documentElement);

          // } else {
          //   if (libType == "footprint") {
          //     place.classList.remove("image-footprint");
          //   } else {
          //     place.classList.remove("image-symbol");
          //   }

          //   place.classList.remove("image-zoom");
          //   place.innerHTML = "<p>No image<br></p>";
          //   if (pinplace != null) {
          //     pinplace.classList.add("nodisplay");
          //   }
          // }

          
          

          
        }
        
            
        
      },
      loadDataForRevisions() {

        
        this.verCounter = 0;
        this.properties = [];
        this.propertiesRevNumbers = [];

        let vue = this;
        
        for (let i = 0, lei = this.selectedRevisionRow.length; i < lei; i++){

          
          let obj = {
            revisionId: this.selectedRevisionRow[i].revisionId,
            revision: this.selectedRevisionRow[i].revision
            
          }
          

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibrary", obj)
          .then(function(result) {
            
            if (result.status == "OK"){
              result.data.sort(function(a, b){return a.priority-b.priority});
              
              vue.properties.push(result.data);
              vue.pureProperties = result.data;
              
              vue.propertiesRevNumbers.push(result.revisionId)
              vue.listAllImageTriggers[result.revisionId] = false;
              
              let rev = result.revision;
              
              let obj = {
                revisionId: result.revisionId
              }

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getFiles", obj)
              .then(function(result) {
                
                console.log(result)

                vue.verCounter++;

                if (result.status == "OK"){

                  
                  vue.listAllRevisionFiles[rev] = result.data;
                  
                  
                }
              })
            }

            

          })

        }

      },
      validateValues(obj) {
        
        let vue = this;

        let arr = [obj];

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateLibraryValidation", arr)
          .then((result) => {

            console.log(result);

            if (result.status == "OK") {
              if (result.data.valid == false) {


                for (let i = 0, lei = result.data.violatedRules.length; i < lei; i++) {

                  vue.displayValidationRules(result.data.violatedRules[i])
                }
              } else {
                vue.resetValidationRules(obj);
              }
            }



          })


      },
      displayValidationRules(obj) {

        let id = "value__" + obj.propertyId;
        let elem = document.getElementById(id);
        elem.classList.add("warning");

        let idInvalidFeedback = id + "__invalid";
        let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
        elemInvalidFeedback.setAttribute("style", "display: block");
        elemInvalidFeedback.innerHTML = obj.message;

      },
      resetValidationRules(obj) {

        let id = "value__" + obj.propertyId;
        let elem = document.getElementById(id);
        elem.classList.remove("warning");

        let idInvalidFeedback = id + "__invalid";
        let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
        elemInvalidFeedback.setAttribute("style", "display: none");
        elemInvalidFeedback.innerHTML = "";
      },
      checkFormValidationAfterLoad() {


        let editParts = document.getElementsByClassName('edit-part');

        for (var i = 0; i < editParts.length; i++) {

          let temp = editParts[i].id.split("__")

          const validObj = {
            propertyId: temp[1],
            value: editParts[i].value,
          }
          this.validateValues(validObj);


        }

      },
      pinsToggle() {


      let checkboxPinOptions = document.getElementsByClassName('checkboxPinOptionDetails');


      for (var i = 0; i < checkboxPinOptions.length; i++) {
        checkboxPinOptions[i].addEventListener('click', function () {

          let svg = document.getElementById("imageDetails__" + this.dataset.revisionid);

          const pinsNameslayers = svg.querySelectorAll('[class="PINS_NAMES"]')

          const pinsNumberlayers = svg.querySelectorAll('[class="PINS_NUMBERS"]')
        
          if (this.checked == true) {
            for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
              pinsNumberlayers[i].style.display = "none";
            }
            for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
              pinsNameslayers[i].style.display = "block";
            }


          } else {
            for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
              pinsNumberlayers[i].style.display = "block";
            }
            for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
              pinsNameslayers[i].style.display = "none";
            }


          }


        })
      }
    },
      buildTable(_dataTable){
        
        

        if (this.isEdit == true){

          this.$store.dispatch("resetPropertyToSaving");
          this.$store.dispatch("resetLibraryFilesToSaving");

          
          for (let i = 0, lei = _dataTable.length; i < lei; i++){
            
            if (_dataTable[i].id != 1){
              let obj = {
                propertyId: _dataTable[i].id,
                value: _dataTable[i].value,
                isRequiredOnRequest: _dataTable[i].isRequiredOnRequest
              }

              this.$store.dispatch("addPropertyToSaving", obj);
            }
            

          }

        }
        

        var tableplace = document.getElementById(this.id);
        if (tableplace == null) {
          return;
        }
        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }

        var table = document.createElement("table");
        table.setAttribute("id", "t_" + this.id);
        table.setAttribute("class", "table table-striped table-bordered");
        table.setAttribute("style", "width:100%;");
        tableplace.appendChild(table)

        var tr1 = document.createElement("tr");

        var tr2 = document.createElement("tr");

        var thead = document.createElement("thead");
        thead.appendChild(tr1);
        thead.appendChild(tr2);

        table.appendChild(thead);

        let vue = this;


        let cols =  [
          { "data": "id" },
          { "data": "priority" },
          { "data": "name" },
        ]

        for (let el in _dataTable[0]){

          let pos = el.indexOf("value___");
          if (pos > -1){
            let obj = {
              "data": el
            }
            cols.push(obj);
          }

        }

        let columns = [
          {
            name: "Id",
            alignInColumn: "left",

          },
          {
            name: "Priority",
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Name,
            alignInColumn: "left",

          },



        ]

        for (let i = 0, lei = this.selectedRevisionRow.length; i < lei; i++){
          let obj = {
            name: this.lang.table_header_Value,
            alignInColumn: "left",

          }
          columns.push(obj)
        }


        var columnDefs = [];
        
        
        for (var i = 0, len = columns.length; i < len; i++){

          let classname = '_dt-body-'+ columns[i].alignInColumn;

          let  el = {
              targets: i,
              className: classname,
              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }

                
                
                if (meta.col == 1){
                  return data;
                }
                if (meta.col == 2){
                  let strName = "<span class=\"name-column\">" + data + "</span>";
                  let required = "<span class=\"required\">";
                  if (vue.isEdit == true&&vue.selectedLastRevisionRow == true){
                    if (row.isRequiredOnRequest == true){
                      required += "<b-badge class=\"badge badge-blue\">Request</b-badge>";
                    }
                    if (row.isRequiredOnRelease == true){
                      required += "<b-badge class=\"badge badge-yellow\">Release</b-badge>";
                    }
                    if (row.isRevisionChanging == true){
                      required += "<b-badge class=\"badge badge-danger\">Revision</b-badge>";
                    }
                    required += "</span>"
                  }
                  return strName + "   " + required;
                }
                if (meta.col > 2){


                  if (meta.col > 3){
                    
                    let colorClass = "", colorClassImg = "";
                    let str = "";
                    if (row.isTheSameLikeLastRev == true){
                      colorClass = "green";
                      colorClassImg = "green-img";
                    }else{
                      colorClass = "red";
                      colorClassImg = "red-img";
                    }
                    let rev = meta.col - 3
                    if (row.type == LibraryPropertiesType.IMAGE){
                      
                      let revisionId = vue.selectedRevisionRow[rev].revisionId;
                      let id = "imageDetails__"+ + revisionId;

                      let barid = "bar_imageDetails__"+ revisionId + "_" +  vue.id;
                      let bar = "<div id=\""+barid+"\" class=\"bar-symbol\"></div>";

                      let pinOption = "<span id=\"pin_" + id + "\" class=\"nodisplay\"><input data-revisionid=\"" + revisionId + "\" class=\"checkboxPinOptionDetails\" type=\"checkbox\" value=\"\"> " + vue.lang.label_pinSwitch + "</span>";
                      if (vue.libraryType != LibraryTypes.PART) {
                        pinOption = "";
                      }
                      //let id = "imageDetails__" + vue.selectedRevisionRow[rev].revisionId;

                      let loader = "<div id=\"loader_" + id + "\" class=\"d-flex justify-content-center mb-3 loader\"><span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"> </span></div>";
                      
                      let image = loader + "<div id=\"" + id + "\"  data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\""+vue.libraryType+"\" class=\"image-footprint image-zoom nodisplay\"></div>" + pinOption + bar;


                        const obj = {
                          type:  vue.libraryType,
                          name: data.display,
                          id: id,
                          revisionId: revisionId
                        }
                        
                        if (data.display != ""){
                          if(vue.listAllImageTriggers[revisionId] === false){
                            vue.listAllImageTriggers[revisionId] = true;
                            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                            .then((result) => {
                              
                              if (result != null){
                                
                                
                                let id = result.id;
                                let revisionId = result.revisionId;                          
                                vue.loadSVG(result, id, revisionId, vue.libraryType);
                                
                                
                              }
                            
                            })
                          }
                        }else{
                          image = data.display;
                        }
                                                
                        return image;

                    }
                    if(row.type == LibraryPropertiesType.TEXT){
                      
                        
                      str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                    }
                    if (row.type == LibraryPropertiesType.LINK) {


                      str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                    }
                    if (row.type == LibraryPropertiesType.LIBRARYNUMBER){
                        
                        
                      str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                    }
                    if (row.type == LibraryPropertiesType.LIBRARYTYPE){
                        
                        
                      str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                    }
                    if (row.type == LibraryPropertiesType.NUMBEROFPINS){
                        
                        
                      str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                    }
                    if (row.type == LibraryPropertiesType.NUMBEROFMECHPINS){
                      
                      
                      str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                    }
                    
                    if (row.type == LibraryPropertiesType.FILES){

                      if (vue.libraryType == LibraryTypes.HDLSYMBOL) {
                        let str = "";
                        if (vue.selectedRevisionRow[rev] != undefined) {
                          str = "<span id=\"value___" + vue.selectedRevisionRow[rev].revisionId + "\"></span>";
                        }
                        return str;
                      } else {
                        str += "<table class=\"file-table\">";
                        for (let i = 0, lei = vue.listAllRevisionFiles[vue.selectedRevisionRow[rev].revision].length; i < lei; i++) {
                          str += "<tr class=\"file-tr\">"
                          str += "<td>"
                          let file = vue.listAllRevisionFiles[vue.selectedRevisionRow[rev].revision][i];
                          let classColor = "green";
                          if (vue.listAllRevisionFiles[vue.selectedRevisionRow[rev].revision][i].dif == false) {
                            classColor = "red";
                          }
                          let src = Tools.filenameToIcon(file.name);
                          str += "<a id=\"download_^_" + file.guid + "_^_" + file.name + "_^_" + vue.selectedRevisionRow[rev].revisionId + "\" class=\"button-action-download\" href=\"#\"><img width=16px src=\"" + src + "\"> ";
                          str += file.name + "</a></td><td class=\"" + classColor + "\">" + file.size + "</td><td class=\"" + classColor + "\">" + Tools.longDateToShort(file.modificationDate) + "   <br>";
                          str += "</td>"
                          str += "</tr>"
                        }

                        str += "</table>";
                        return str;
                      }
                        
                    }
                    return str;
                  }else{


                    if (vue.isEdit == true&&vue.selectedLastRevisionRow == true){
                      
                      let rev = meta.col - 3;
                      if (row.type == LibraryPropertiesType.TEXT){
                        let str = "";
                        
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                        str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                        return str;
                      }
                      if (row.type == LibraryPropertiesType.LIBRARYNUMBER) {
                        let str = "";

                        str += "<input disabled=\"disabled\" data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                        str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                        return str;
                      }

                      if (row.type == LibraryPropertiesType.LIBRARYTYPE) {
                        let str = "";

                        str += "<input disabled=\"disabled\" data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                        str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                        return str;
                      }
                      
                      if (row.type == LibraryPropertiesType.LINK) {
                        let str = "";
                        
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                        str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                        return str;
                      }
                      
                                                
                      if (row.type == LibraryPropertiesType.FILES) {

                        if (vue.libraryType == LibraryTypes.HDLSYMBOL) {
                          let str = "";
                          if (vue.selectedRevisionRow[rev] != undefined) {
                            str = "<span id=\"value___" + vue.selectedRevisionRow[rev].revisionId + "\"></span>";
                          }
                          return str;
                        } else {

                          let str = "";
                          str += "<table class=\"file-table\">";
                          for (let i = 0, lei = vue.listAllRevisionFiles[vue.selectedRevisionRow[rev].revision].length; i < lei; i++) {
                            str += "<tr class=\"file-tr\">"
                            str += "<td>"
                            let file = vue.listAllRevisionFiles[vue.selectedRevisionRow[rev].revision][i];

                            let src = Tools.filenameToIcon(file.name);
                            str += "<a id=\"download_^_" + file.guid + "_^_" + file.name + "_^_" + vue.selectedRevisionRow[rev].revisionId + "\" class=\"button-action-download\" href=\"#\"><img width=16px src=\"" + src + "\"> ";
                            str += file.name + "</a></td><td>" + file.size + "</td><td>" + Tools.longDateToShort(file.modificationDate) + "   <br>";
                            str += "</td><td><button class=\"btn btn-secondary btn-sm btn-" + vue.variant + " button_action_delete_file\" id=\"button_deleteFile___" + file.guid + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\">" + vue.lang.button_DeleteFile + "</button></td>";
                            str += "</tr>"
                          }

                          str += "</table>";
                          return str;
                        }
                    }
                      
                      if (row.type == LibraryPropertiesType.NUMBEROFPINS){
                        let str = "";
                        
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                        str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                        return str;
                      }
                      if (row.type == LibraryPropertiesType.NUMBEROFMECHPINS){
                        let str = "";
                        
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                        str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                        return str;
                      }
                      if (row.type == LibraryPropertiesType.PLACEBOUNDWIDTH) {
                        let str = "";

                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                        str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                        return str;
                      }                          
                      if (row.type == LibraryPropertiesType.PLACEBOUNDHEIGHT) {
                        let str = "";

                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                        str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                        return str;
                      }

                      if (row.type == LibraryPropertiesType.IMAGE){
                        // if (data.display == ""){
                        //   return "<img src=\"/static/noimage.svg\" class=\"image-footprint\">";
                        // }
                        let revisionId = vue.selectedRevisionRow[rev].revisionId;

                        let barid = "bar_imageDetails__"+ revisionId + "_" +  vue.id;
                        let bar = "<div id=\""+barid+"\" class=\"bar-symbol\"></div>";
                        let pinOption = "<span id=\"pin_" + id + "\" class=\"nodisplay\"><input data-revisionid=\"" + revisionId + "\" class=\"checkboxPinOptionDetails\" type=\"checkbox\" value=\"\"> " + vue.lang.label_pinSwitch + "</span>";
                        
                        if (vue.libraryType != LibraryTypes.PART) {
                          pinOption = "";
                        }
                        let id = "imageDetails__" + revisionId;

                        let loader = "<div id=\"loader_" + id + "\" class=\"d-flex justify-content-center mb-3 loader\"><span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"> </span></div>";

                        let image = loader + "<div id=\"" + id + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\""+vue.libraryType+"\" class=\"image-footprint image-zoom nodisplay\"></div>" + pinOption + bar ;

                        

                        const obj = {
                          type:  vue.libraryType,
                          name: data.display,
                          id: id,
                          revisionId: revisionId
                        }
                        
                        if (data.display != ""){
                          if(vue.listAllImageTriggers[revisionId] === false){
                            vue.listAllImageTriggers[revisionId] = true;
                            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                            .then((result) => {
                              
                              if (result != null){
                                
                                
                                let id = result.id;                          
                                let revisionId = result.revisionId;                          
                                vue.loadSVG(result, id, revisionId, vue.libraryType);
                                
                                
                              }
                            
                            })
                          }
                        }else{
                          image = data.display;
                        }
                                                
                        return image;

                      }
                                              
                      

                      return data.display;
                    }else{
                      
                      let rev = meta.col - 3
                      
                      if (row.type == LibraryPropertiesType.IMAGE){
                        
                        // if (data.display == ""){
                        //   return "<img src=\"/static/noimage.svg\" class=\"image-footprint\">";
                        // }
                        
                        let revisionId = vue.selectedRevisionRow[rev].revisionId;
                        let id = "imageDetails__" + revisionId;

                        let barid = "bar_imageDetails__"+ revisionId + "_" +  vue.id;
                        let bar = "<div id=\""+barid+"\" class=\"bar-symbol\"></div>";
                        let pinOption = "<span id=\"pin_" + id + "\" class=\"nodisplay\"><input data-revisionid=\"" + revisionId + "\" class=\"checkboxPinOptionDetails\" type=\"checkbox\" value=\"\"> " + vue.lang.label_pinSwitch + "</span>";
                        
                        if (vue.libraryType != LibraryTypes.PART) {
                          pinOption = "";
                        }

                        let loader = "<div id=\"loader_" + id + "\" class=\"d-flex justify-content-center mb-3 loader\"><span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"> </span></div>";

                        let image = loader + "<div id=\"" + id + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\""+vue.libraryType+"\" class=\"image-footprint image-zoom nodisplay\"></div>" + pinOption + bar;

                        

                        const obj = {
                          type:  vue.libraryType,
                          name: data.display,
                          id: id,
                          revisionId: revisionId
                        }
                        
                        if (data.display != ""){
                          if(vue.listAllImageTriggers[revisionId] === false){
                            vue.listAllImageTriggers[revisionId] = true;
                            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                            .then((result) => {
                              
                              if (result != null){
                                
                                
                                let id = result.id;                          
                                let revisionId = result.revisionId;                          
                                vue.loadSVG(result, id, revisionId, vue.libraryType);
                                
                                
                              }
                            
                            })
                          }
                        }else{
                          image = data.display;
                        }
                                                
                        return image;

                      }
                      if (row.type == LibraryPropertiesType.LINK) {

                      if (data.display != null) {
                        let link = data.display;
                        let pos = -1;
                        if (vue.globalSettings.displayHttpLinks == true) {

                          pos = link.indexOf("http");

                          if (pos > -1) {
                            return "<a href='" + link + "' target='_blank'>Link</a>";
                          }
                        }
                        if (vue.globalSettings.displayLocalLinks == true) {
                          pos = link.indexOf("\\\\");
                          if (pos > -1) {

                            link = link.split('\\').join('/');

                            link = "file:///" + link
                            return "<a href='" + link + "' target='_blank'>Local link</a>";
                          }
                          pos = link.indexOf("file://");
                          if (pos > -1) {

                            return "<a href='" + link + "' target='_blank'>Local link</a>";
                          }
                        }


                      } else {
                        return "";
                      }
                    }
                      if (row.type == LibraryPropertiesType.FILES){

                        if (vue.libraryType == LibraryTypes.HDLSYMBOL) {
                          let str = "";
                          if (vue.selectedRevisionRow[rev] != undefined) {
                            str = "<span id=\"value___" + vue.selectedRevisionRow[rev].revisionId + "\"></span>";
                          }
                          return str;
                        } else {
                          let str = "";
                          str += "<table class=\"file-table\">";
                            
                            
                          for (let i = 0, lei = vue.listAllRevisionFiles[vue.selectedRevisionRow[rev].revision].length; i < lei; i++) {
                            str += "<tr class=\"file-tr\">"
                            str += "<td>"
                            let file = vue.listAllRevisionFiles[vue.selectedRevisionRow[rev].revision][i];

                            let src = Tools.filenameToIcon(file.name);
                            str += "<a id=\"download_^_" + file.guid + "_^_" + file.name + "_^_" + vue.selectedRevisionRow[rev].revisionId + "\" class=\"button-action-download\" href=\"#\"><img width=16px src=\"" + src + "\"> ";
                            str += file.name + "</a></td><td>" + file.size + "</td><td>" + Tools.longDateToShort(file.modificationDate) + "   <br>";
                            str += "</td>"
                            str += "</tr>"
                          }
                          str += "</table>";

                          return str;
                        }
                    }
                      let image = "";
                      

                      return data.display + image;
                    }

                  }


                }

                return data;
              }
            }

          columnDefs.push(el);
         
          if (i < 4){
            var th1 = document.createElement("th");
            th1.setAttribute("id", i);
          }

          if (i < 3){
            th1.setAttribute("rowspan", "2");
          }
          if (i == 3){
            let colspan = len - i;

            th1.setAttribute("colspan", colspan);
          }


          if (i > 2){
            var th2 = document.createElement("th");

          }


          if (i < 4){
            var p1 = document.createElement("p");
            var tx1 = document.createTextNode(columns[i].name)
            
            th1.appendChild(tx1);
          }


          if (i > 2){

            var p2 = document.createElement("p");
            let rev = i - 3;
            var br = document.createElement("br");
            th2.appendChild(br);
            var tx2 = document.createTextNode(this.lang.table_subheader + " " + this.selectedRevisionRow[rev].revision)
            //p2.appendChild(tx2);

          }
          tr1.appendChild(th1);

          if (i > 2){
            th2.appendChild(tx2);
            tr2.appendChild(th2);
          }

          
        }
       console.log(_dataTable)

        var json = {};
        json.paging = false;
        json.info = false;
        json.dom = 'f<t>';
        json.data= _dataTable;
        json.myColumnFormats = columns;
        json.select = false;
        json.columns = cols;
        json.columnDefs = columnDefs;
        json.order = [1, "asc"];
        json.initComplete = function () {

          vue.checkFormValidationAfterLoad();
          vue.pinsToggle();
        }

        if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
            this.mainTable.destroy();
            
        }

        

        this.mainTable = $('#t_'+this.id).DataTable(json);


        this.mainTable.columns.adjust().draw();

        //hide first column in table
        this.mainTable.column( 0 ).visible( false );
        this.mainTable.column( 1 ).visible( false );

        //search input change view
        var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

        while (searchplace.firstChild) {

          if (searchplace.firstChild.textContent == "Search:"){
              searchplace.removeChild(searchplace.firstChild);
              break;
          }

        }

        searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
        searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

        

        let editParts = document.getElementsByClassName('edit-part');

          for (var i = 0; i < editParts.length; i++) {
            editParts[i].addEventListener('input', function (e){

              let temp = this.id.split("__");
              let propertyId = parseInt(temp[1]);
              let type = this.dataset.type;
              let isRequiredOnRequest = this.dataset.isRequiredOnRequest === "true";


              
              let obj = {
                propertyId: propertyId,
                value: this.value,
                type: type,
                isRequiredOnRequest: isRequiredOnRequest
              }
              const validObj = {
                propertyId: propertyId,
                value: this.value,
              }
              vue.validateValues(validObj);

              vue.$store.dispatch("addPropertyToSaving", obj);

              vue.checkIfSaved();
            })
        }

        for (var i = 0; i < editParts.length; i++) {
          editParts[i].addEventListener('focus', function (e) {

            let temp = this.id.split("__");

            let obj = {
              propertyId: temp[1],
              categoryId: vue.$store.getters.selectedTreeLibraryItemObject.categoryId
            }


            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getAutocompleteValues", obj)
              .then((result) => {
                console.log(result)
                let str = "";
                for (let i = 0, lei = result.data.length; i < lei; i++) {
                  str += "<option>" + result.data[i] + "</option>";
                }

                let place = document.getElementById("datalist__" + temp[1])
                if (place == null) {
                  return
                }
                place.innerHTML = str;


              })
          })
        }

        let symbols_buttons = document.getElementsByClassName('button_action_symbol');

        for (let i = 0, lei = symbols_buttons.length; i < lei; i++) {
          symbols_buttons[i].addEventListener('click', function (e){

            let id = this.id;
            let temp = id.split("__");
            let f = document.getElementById("value__" + temp[1] + "__" + temp[2])
            

            let selectedSymbols = f.value;

            let funcYes = function(vue){

              let temp = id.split("__");

              //let f = document.getElementById("value__" + temp[1] + "__" + temp[2])

              let str = "";
              for(let i = 0, lei = vue.$store.getters.selectedSymbols.length; i < lei; i++){
                str += vue.$store.getters.selectedSymbols[i];
                if (i < lei - 1){
                  str += ",";
                }

              }
              
              f.value = str;

              const obj = {
                propertyId: temp[1],
                value: str,
                isRequiredOnRequest: temp[2]
              }


              vue.$store.dispatch("addPropertyToSaving", obj);
              
            }

            const obj = {
              title: "Symbols",
              text: "",
              type: "symbols",
              buttons: 2,
              size: "lg",
              selected: selectedSymbols,
              lang: vue.lang.modal_Symbols,
              funcNo: "",
              funcYes: funcYes,
              
            };
            vue.$store.dispatch("showModalComponent", obj);
          })
        }

        let footprints_buttons = document.getElementsByClassName('button_action_footprint');

        for (let i = 0, lei = footprints_buttons.length; i < lei; i++) {
          footprints_buttons[i].addEventListener('click', function (e){
            let id = this.id;
            let temp = id.split("__");
            let f = document.getElementById("value__" + temp[1] + "__" + temp[2])              
            
          
            let selectedFootprint = f.value;

            let funcYes = function(vue){

              

              
              
              f.value = vue.$store.getters.selectedFootprints;

              const obj = {
                propertyId: temp[1],
                value: vue.$store.getters.selectedFootprints[0],
                isRequiredOnRequest: temp[2]
              }


              vue.$store.dispatch("addPropertyToSaving", obj);
              
            }

            const obj = {
              title: "Footprints",
              text: "",
              type: "footprints",
              buttons: 2,
              size: "lg",
              selected: selectedFootprint,
              lang: vue.lang.modal_Footprints,
              funcNo: "",
              funcYes: funcYes,
              
            };
            vue.$store.dispatch("showModalComponent", obj);
          })
        }  

        
        let download_buttons = document.getElementsByClassName('button-action-download');

        for (let i = 0, lei = download_buttons.length; i < lei; i++) {
          download_buttons[i].addEventListener('click', function (e){
            let id = this.id;
            let temp = id.split("_^_");
            
            
            const obj = {
              fileId: temp[1],
              revisionId: temp[3]
              
            }


            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_downloadFile", obj)
            .then((result) =>{


                console.log(result)
                let fileName = temp[2];
    
                var a = document.createElement("a");
                a.href = URL.createObjectURL(result);
                a.download = fileName;
                
                document.body.appendChild(a);
                
                a.click();
                document.body.removeChild(a);
            })
          })
        }  

        let buttons_action_deleteFile = document.getElementsByClassName('button_action_delete_file');


        for (var i = 0; i < buttons_action_deleteFile.length; i++) {
          buttons_action_deleteFile[i].addEventListener('click', function (){

            let _vue = vue;
            
            let temp = this.id.split("___")
            let guid = temp[1];
            
            let revisionId = this.dataset.revisionid;
            

            let deleteFile = function(){
                                  
              let obj = {
                revisionId: revisionId,
                guid: guid
              }
              

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_removeFileFromRevision", obj)
              .then(function(result) {
                
                console.log(result)

                if (result.status == "OK"){
                  if (result.data != null){


                    const obj = {
                      text: vue.lang.alert_success_DeleteFile,
                      time: 10,
                      type: "success"
                    }

                    vue.$store.dispatch("displayFooterAlert", obj);

                    
                    const reloadObj = {
                        status: true,
                        name: "RevisionTableComponent"
                    }
                    vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  }else{
                    

                    const obj = {
                      text: vue.lang.alert_error_DeleteFile + ".",
                      time: 15,
                      type: "danger"
                    }

                    vue.$store.dispatch("displayFooterAlert", obj);

                  }
                }else{
                  const obj = {
                    text: vue.lang.alert_error_DeleteFile + ": " + result.message,
                    time: 15,
                    type: "danger"
                  }

                  vue.$store.dispatch("displayFooterAlert", obj);

                }
                



              })
            }
                          

            

            var obj = {
              title: vue.lang.alert_Title_deleteFile,
              text: vue.lang.alert_deleteFile,
              type: "sure",
              buttons: 2,
              size: "sm",
              funcNo: "",
              funcYes: deleteFile

            }
            vue.$store.dispatch("showAlert", obj);



          }, false);
        }

        let image_zoom = document.getElementsByClassName("image-zoom");

        if (image_zoom != null) {

          for (let i = 0, lei = image_zoom.length; i < lei; i++) {
            image_zoom[i].addEventListener("click", function (e) {


              let currentLib = this.dataset.name;
              

              const svgObject = {
                type: this.dataset.type,
                name: currentLib,
                id: this.dataset.type + "__" + this.dataset.revisionid,
                revisionId: this.dataset.revisionid
              }

              const langObj = {
                modal_Title: currentLib,
                label_pinSwitch: vue.lang.label_pinSwitch
              }

              const obj = {
                title: currentLib,
                text: "",
                type: "zoom_svg",
                buttons: 1,
                buttonName: vue.lang.modal_ZoomSvg.button_Close,
                size: "xl",
                lang: langObj,
                funcNo: "",
                funcYes: "",
                funcCustom: "",
                svgObject: svgObject
              };

              vue.$store.dispatch("showModalComponent", obj);

            })

          }

        }

        function trees() {
          for (let i = 0, lei = vue.propertiesRevNumbers.length; i < lei; i++) {
            let tree = document.getElementById("value___" + vue.propertiesRevNumbers[i]);
            
            if (tree != null) {
              let tree_instance = document.getElementById("place_" + vue.propertiesRevNumbers[i])

              if (tree_instance != null) {
                let a = tree.appendChild(tree_instance);


              } else {
                tree_instance.style.display = "none";
              }
            } else {
              let tree_instance = document.getElementById("place_" + vue.propertiesRevNumbers[i])

              if (tree_instance != null) {
                tree_instance.style.display = "none";


              }
            }

          }
        }
        if (vue.libraryType == LibraryTypes.HDLSYMBOL) {
          setTimeout(trees, 200);
        } 
        
      },

        }

  }
</script>
<style lang="scss">


  @import "./../../scss/_custom.scss";

  .LibraryDetailsComponent{
    table{

      padding: 0px !important;

    }
    table th {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }

    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_filter{
      font-size: 10px;
    }
    .searcher{
      float: left;
    }
    .dataTables_filter .form-control-sm {
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $orange;
      //font-weight: 700;
    }
    .blue{
      color: $blue;
      font-weight: 700;
    }
    .yellow{
      color: $yellow;
      font-weight: 700;
    }
    .red-img{
      background-color: $red;
      border: 0px;
    }
    .green{
      color: $lightgreen;
      //font-weight: 700;
    }
    .green-img{
      background-color: $green;
      border: 0px;
    }
    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }

    .btn{
      height: 26px;
    }
    td{
      word-break: break-all;
    }
    input-group{
      min-width: 200px;
    }
    .img-thumbnail{
      width: 250px;
    }
    .image-symbol{
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-bottom: 3px;
      margin-top: 3px;
      overflow: hidden;
      width: 200px;
      height: 200px;
      display: block;
      
    }
    .image-footprint{
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-bottom: 3px;
      margin-top: 3px;
      overflow: hidden;
      width: 200px;
      height: 200px;
    }
    .image-zoom {
      cursor: zoom-in;
    }
    svg{
      display: block;
      width: 200px;
      height: 200px;
      overflow: hidden;
      
    }
    .bar-symbol{
      margin-top: 5px;
      margin-bottom: 5px;
      width: 200px;
    }
    .btn-bar{
      height: 31px;
    }
    .symbol_select{
      padding: 1px;
    }
    .required{
      float: right;
      margin: 4px;
    }
    .type-select{
      padding-top: 5px;
      font-size: 0.7rem;
      padding-left: 5px;
    }
    .badge{
      margin-right: 3px;
    }
    .button-action-download{
      margin: 2px;
      padding: 0rem 0.5rem;
      height: 22px;
    }
    .button_action_delete_file{
      margin-bottom: 2px;
      margin-top: 2px;
      padding-top: 1px;
      padding-bottom: 1px;
      height: 20px;
      
    }
    .file-table{
      width: 100%;
      border-style: hidden;
      //border-color: #666;
    }
    .file-tr{
      
      border-style: hidden;
      //border-color: #666;
    }
    .file-td{
      
      //border-style: hidden;
      //border-color: #666;
    }
    input::-webkit-calendar-picker-indicator {
      opacity: 0;
    }
    .warning{
      border-color: $redfont !important;
    }
    .invalid{
      color: $redfont;
      font-size: 0.7rem;
      display: none;
    }
    .edit-part{
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .name-column{
      white-space: break-spaces;
    }
    .nodisplay{
      display: none !important;
    }
    .pin-symbol {
       margin-left: 5px;
    }
    .loader{
      margin: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/LibraryDetailsComponent.vue